import { css, GridCell, Icon, Message, Theme } from "@bdfx/mergado-ui-kit"
import { URL } from "app/config/api-config"
import * as React from "react"

interface Props {
}

interface State {
    copiedText: string
}

class MCPSettings extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
            copiedText: null
        }
    }

    copyToClipboard = (text: string) => {
        navigator.clipboard.writeText(text)
        this.setState({ copiedText: text })
    }

    render() {
        const mcpRoot = URL.rootUrl.replace('api', 'mcp')
        const mcpConnect = [
            'claude mcp add feed-image-editor',
            `  --transport http ${mcpRoot}`,
            '  --header "Authorization: Bearer mergado_pat_..."',
        ].join('\n')

        const { copiedText } = this.state
        return (
            <StyledContent>
                <p>
                    Feed Image Editor podporuje <b>Model Context Protocol</b> (MCP), který umožňuje propojit rozšíření s AI klientem (jako je Claude,
                    Cursor, Windsurf, VS Code atd.). Díky tomu můžete jednodušeji a efektivněji pracovat s daty projektů pomocí přirozeného jazyka.
                </p>

                <p>
                    MCP server URL: <code style={{
                        border: '1px solid #efefef',
                        marginLeft: '10px',
                        padding: '5px',
                        fontSize: 'small',
                        borderRadius: '10px'
                    }}>https://mcp.mergado.com</code>
                </p>

                <h3>Jak MCP napojit?</h3>
                <p>
                    <b>Již používáte Mergado MCP?</b> Máte automaticky přístup i k Feed Image Editoru. Žádné další nastavení není potřeba.
                </p>
                <p>
                    Pokud MCP ještě nemáte nastavené, potřebujete pro nové napojení <b>Personal Access Token</b> (PAT) pro ověření přístupu.
                </p>

                <h3>Jak získat PAT:</h3>
                <ol>
                    <li>Přihlaste se do svého Mergado účtu</li>
                    <li>Přejděte do sekce <a href="https://app.mergado.com/user/security/" target="_blank" >API a přístupy</a></li>
                    <li>Vytvořte nový token s požadovanou platností a oprávněními (Scopes)</li>
                    <li>Token zkopírujte do schránky – po zavření již nebude zobrazen</li>
                </ol>
                <h3>Připojení k AI klientovi:</h3>
                <p>
                    Vytvořený token předejte do konfigurace AI klienta pomocí následujícího příkazu (nahraďte mergado_pat_ vaším tokenem):
                </p>

                <div className="command" onClick={() => this.copyToClipboard(mcpConnect)}>
                    <Icon
                        type={'clipboard'}
                        size={14}
                        color={copiedText === mcpConnect ? '#ccc' : Theme.blue}
                        style={{
                            position: 'absolute',
                            top: '5px',
                            right: '15px',
                            fontSize: 'small',
                            background: '#efefef',
                        }}
                    />
                    <pre style={{ whiteSpace: 'pre-wrap' }}>
                        <code>{mcpConnect}</code>
                    </pre>
                </div>
            </StyledContent>

        )
    }
}

const StyledContent = css(GridCell)({
    fontSize: 'small',
     whiteSpace: 'normal',
        textAlign: 'left',
        alignSelf: 'center',
    ' .m-item label, .m-item .m-label-wrapper': {
        width: '100%',
    },
    '@media (min-width: 1025px)': {
        padding: '10px',
        float: 'left',
    },
    ' h3': {
        marginTop: '1.2em',
    },
    ' .command': {
        paddingLeft: '15px',
        marginTop: '20px',
        cursor: 'pointer',
        position: 'relative',
        border: '1px solid #dddddd',
        borderRadius: '10px',
    }
})

export default MCPSettings

